import Dialog from '@/components/Dialog';
import React from 'react';

interface PointsRuleProps {
  show: boolean;
  onClose: () => void;
  renderPointsRule: () => React.ReactNode;
}

const PointsRule: React.FC<PointsRuleProps> = ({ show, onClose, renderPointsRule }) => {
  return (
    <Dialog.Confirm open={show} onClose={onClose} okText="OK" onOk={onClose}>
      {/* 规则内容 */}
      {renderPointsRule()}
    </Dialog.Confirm>
  );
};

export default PointsRule;
